import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../../../styles/LoginRegister.module.css';
import buttonStyles from '../../../styles/Buttons.module.css';

const SignupSuccess: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.pageContainer}>
      <div className={styles.formCard}>
        <div style={{ textAlign: 'center', padding: '40px 20px' }}>
          <div style={{ fontSize: '64px', marginBottom: '20px' }}>✉️</div>
          <h2>Check Your Email</h2>
          <p style={{ color: '#555', marginBottom: '24px' }}>
            Your agency account has been created successfully!
            <br /><br />
            We've sent a confirmation email to your registered address.
            Please click the link in that email to verify your account before logging in.
          </p>
          <p style={{ fontSize: '14px', color: '#888', marginBottom: '32px' }}>
            Didn't receive the email? Check your spam folder, or contact{' '}
            <a href="mailto:support@realty-genie.co.za">support@realty-genie.co.za</a>.
          </p>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <button
              className={`${buttonStyles.button} ${buttonStyles.formPrimary}`}
              onClick={() => navigate('/LoginRegister')}
            >
              Go to Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupSuccess;
